import { t } from 'i18next';
import * as yup from 'yup';

import { MIN_PASSWORD_LENGTH } from 'authOld/constants';

export const createPasswordSchema = () =>
  yup.object().shape({
    password: yup.string().label(t('labelPassword')).nullable().required().min(MIN_PASSWORD_LENGTH),
    confirmPassword: yup
      .string()
      .label(t('labelConfirmPassword'))
      .oneOf([yup.ref('password'), null], t('errorPasswordsDoNotMatch'))
      .nullable()
      .required()
      .min(MIN_PASSWORD_LENGTH),
  });
